import React from 'react';
import ReactDOM from 'react-dom';
import mixpanel from 'mixpanel-browser';
import { StylesProvider } from '@material-ui/core/styles';
import ReactGA from 'react-ga4';
import * as Sentry from '@sentry/react';
import { initSentry } from '@nearst/sentry-config';

import App from './App';
import './index.css';
import './index.scss';

// Init MixPanel
mixpanel.init(import.meta.env.PROD ? '4a6a2aabbf45375753d33ebace8685ff' : '74571c2ac65c51a1c943355a94398ba1');

// Init Sentry
if (import.meta.env.PROD) {
	initSentry(Sentry, {
		dsn: 'https://1df4061b0b4f74c07b5565319f16db07@o62538.ingest.us.sentry.io/4511489845362688',
		service: 'unify-dashboard',
		stage: import.meta.env.MODE,

		// Must match the `release` the deploy workflow uploads sourcemaps under, or
		// Sentry has no way to pair an event with its artefacts and every production
		// stack trace stays minified. Injected at build time from VITE_SENTRY_RELEASE.
		release: import.meta.env.VITE_SENTRY_RELEASE,

		replayOnError: true,
		integrations: [new Sentry.Replay()]
	});
}

// Init Mouseflow (session replay for full-session journeys). Mouseflow loads via
// the global `_mfq` queue and a script tag injected at runtime — see
// https://help.mouseflow.com/en/articles/4264201-installation-guide
if (import.meta.env.PROD) {
	window._mfq = window._mfq || [];
	const mf = document.createElement('script');
	mf.type = 'text/javascript';
	mf.defer = true;
	mf.src = '//cdn.mouseflow.com/projects/87411dae-9dfa-454e-8ccc-cd9966d053a4.js';
	document.head.appendChild(mf);
}

// Opt the user out of data tracking if it's not production
if (import.meta.env.DEV) {
	mixpanel.opt_out_tracking();
}
if (import.meta.env.REACT_APP_LOCAL_GA || import.meta.env.PROD) {
	// enable tracking
	ReactGA.initialize('G-CH8YJG3SM6', {
		debug: false, // change to true for chatty console help
		redactEmail: false
	});
	ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search });
}

// Render ReactDOM
ReactDOM.render(
	<React.StrictMode>
		<StylesProvider injectFirst>
			<App />
		</StylesProvider>
	</React.StrictMode>,
	document.getElementById('root')
);
